<template>
  <div class="m-gov-wrapper">
    <!-- 人事管理 -->
    <div class="gov-firstWrapper">
      <div class="list">
        <div class="item">
          <h3>董事会</h3>
          <div class="block">
            <div class="box" v-for="(item, index) in governanceData.DSH" :key="index">
              <h4 class="h4">{{ item.mgrName }}</h4>
              <h3 class="h3">{{ item.jobTitle }}</h3>
            </div>
          </div>
        </div>
        <div class="item">
          <h3>监事会</h3>
          <div class="block">
            <div class="box" v-for="(item, index) in governanceData.JSH" :key="index">
              <h4 class="h4">{{ item.mgrName }}</h4>
              <h3 class="h3">{{ item.jobTitle }}</h3>
            </div>
          </div>
        </div>
        <div class="item">
          <h3>高级管理层</h3>
          <div class="block">
            <div class="box" v-for="(item, index) in governanceData.GJ" :key="index">
              <h4 class="h4">{{ item.mgrName }}</h4>
              <h3 class="h3">{{ item.jobTitle }}</h3>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 公司章程 -->
    <div class="gov-secondWrapper">
      <div class="charter-cont">
        <a :href="charterData && charterData.ruleUrl" target="_blank">
          <div class="txt-box">
            <div class="txt-box-main">
              <div class="line line-top"></div>
              <div class="text-row1">{{ charterData && charterData.title ? (charterData.title.split("公司章程")[0] || "上海艾融软件股份有限公司") : "上海艾融软件股份有限公司" }}</div>
              <div class="text-row2">公司章程</div>
              <div class="tip-date">{{ charterData && charterData.remark }}</div>
              <div class="line line_bottom"></div>
            </div>
            <div class="tip-click">点击查看详情</div>
          </div>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
  import { useGetGovernmentListApi, useGetChartListApi } from "@/api/useGovernmentApi";
  export default {
    name: "GovernmentComp",
    props: {},
    data() {
      return {
        // 公司治理数据
        governanceData: {
          DSH: [],
          JSH: [],
          GJ: [],
        },
        // 公司章程数据
        charterData: null,
      };
    },
    filters: {},
    created() {
      // 获取公司治理数据
      this.fetchAllGovernanceData();
      // 获取公司章程数据
      this.fetchCharterData();
    },
    mounted() {
      window.addEventListener("scroll", this.getScroll);
    },
    destroyed() {
      window.removeEventListener("scroll", this.getScroll);
    },
    methods: {
      // 获取所有治理数据
      async fetchAllGovernanceData() {
        await this.fetchGovernanceData("DSH");
        await this.fetchGovernanceData("JSH");
        await this.fetchGovernanceData("GJ");
      },
      // 根据类型获取治理数据
      fetchGovernanceData(type) {
        const params = {
          pageNum: 1,
          pageSize: 100,
          gvmtType: type,
        };

        // 使用正确的API调用
        return useGetGovernmentListApi(params)
          .then((res) => {
            if (res.records && res.records.length > 0) {
              this.governanceData[type] = res.records;
            }
          })
          .catch((error) => {
            console.error(`获取${type}数据失败:`, error);
          });
      },

      // 获取公司章程数据
      async fetchCharterData() {
        try {
          const res = await useGetChartListApi({
            pageNum: 1,
            pageSize: 10,
          });

          if (res && res.records && res.records.length > 0) {
            this.charterData = res.records[0]; // 使用第一条记录
          }
        } catch (error) {
          console.error("获取公司章程数据失败:", error);
        }
      },

      getScroll() {
        this.scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
        if (!!document.documentElement.scrollTop && document.documentElement.scrollTop >= 70) {
          this.$store.commit("TO_AfterScroll");
        } else {
          this.$store.commit("TO_AfterScroll_false");
        }
      },
    },
  };
</script>

<style lang="less" scoped>
  * {
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  }

  .m-gov-wrapper {
    .gov-firstWrapper {
      padding: 10px;
      margin-bottom: 30px;
      .list {
        .item {
          .block {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            gap: 10px;

            .box {
              padding: 20px 30px;
              opacity: 1;
              background: #eaeff3;

              .h4 {
                font-size: 14px;
                font-weight: 600;
                line-height: 14px;
                text-align: center;
                letter-spacing: 0px;
                color: #666666;
              }

              .h3 {
                font-size: 16px;
                font-weight: 500;
                line-height: 16px;
                text-align: center;
                letter-spacing: 0px;
                color: #333333;
              }
            }

            .box:hover {
              background-color: #f3d8b8;
              color: #b08d57;
              box-shadow: 0px 8px 32px 0px rgba(0, 0, 0, 0.16);

              .h4 {
                color: #b08d57;
              }

              .h3 {
                color: #b08d57;
              }
            }

            .box:active {
              background-color: #f3d8b8;
              color: #b08d57;
              box-shadow: 0px 8px 32px 0px rgba(0, 0, 0, 0.16);

              .h4 {
                color: #b08d57;
              }

              .h3 {
                color: #b08d57;
              }
            }
          }
        }
      }
    }

    .gov-secondWrapper {
      height: 296px;
      background-image: url("https://img.i2soft.net/i2official-web/v2/assets/images/relations/phone/gov_constitutionback.png");
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;
      overflow: hidden;

      .charter-cont {
        height: 100%;

        a {
          width: 100%;
          height: 100%;
          text-decoration: none;

          .txt-box {
            width: 100%;
            height: 100%;
            padding: 25px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            color: #ffffff;
            line-height: normal;
            letter-spacing: 0em;

            .txt-box-main {
              padding: 10px 0;
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              row-gap: 10px;

              .line {
                width: 202px;
                height: 36px;
                border-left: 1px solid #ffffff;
                border-right: 1px solid #ffffff;
              }
              .line-top {
                border-top: 1px solid #ffffff;
              }
              .line-bottom {
                border-bottom: 1px solid #ffffff;
              }
              .text-row1 {
                font-size: 24px;
                font-weight: 500;
              }

              .text-row2 {
                font-size: 28px;
                font-weight: 900;
              }

              .tip-date {
                font-size: 9px;
                font-weight: 300;
              }
            }
            .tip-click {
              font-size: 12px;
            }
          }
        }
      }
    }
  }
</style>
